import { jsx } from "react/jsx-runtime";
import { c } from "react-compiler-runtime";
import { useLexicalComposerContext } from "@lexical/react/LexicalComposerContext";
import { $getRoot, $getSelection, $isRangeSelection, CLEAR_EDITOR_COMMAND, CLEAR_HISTORY_COMMAND, FORMAT_ELEMENT_COMMAND, FORMAT_TEXT_COMMAND } from "lexical";
import { REMOVE_LIST_COMMAND } from "@lexical/list";
import { Box } from "../../../../Box/index.js";
import { Button } from "../../../../Button/index.js";
import { Icon } from "../../../../Icon/index.js";
import SendButton_styles from "./SendButton.styles.js";
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) resolve(value);
    else Promise.resolve(value).then(_next, _throw);
}
function _async_to_generator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(void 0);
        });
    };
}
const SendFormPlugin = (t0)=>{
    const $ = c(10);
    const { handleSendClick, hasContent, isSubmitting: t1 } = t0;
    const isSubmitting = void 0 === t1 ? false : t1;
    const { classes } = SendButton_styles();
    const [editor] = useLexicalComposerContext();
    let t2;
    if ($[0] !== editor || $[1] !== handleSendClick) {
        t2 = ()=>_async_to_generator(function*() {
                let actionStatus = "complete";
                if (handleSendClick) {
                    const status = yield handleSendClick();
                    actionStatus = status;
                }
                if ("failed" === actionStatus) return;
                editor.update(()=>{
                    const selection = $getSelection();
                    const root = $getRoot();
                    root.clear();
                    editor.dispatchCommand(CLEAR_EDITOR_COMMAND, void 0);
                    editor.dispatchCommand(CLEAR_HISTORY_COMMAND, void 0);
                    editor.dispatchCommand(REMOVE_LIST_COMMAND, void 0);
                    editor.dispatchCommand(FORMAT_ELEMENT_COMMAND, "left");
                    if ($isRangeSelection(selection)) {
                        if (selection.hasFormat("bold")) editor.dispatchCommand(FORMAT_TEXT_COMMAND, "bold");
                        if (selection.hasFormat("italic")) editor.dispatchCommand(FORMAT_TEXT_COMMAND, "italic");
                        if (selection.hasFormat("underline")) editor.dispatchCommand(FORMAT_TEXT_COMMAND, "underline");
                        if (selection.hasFormat("strikethrough")) editor.dispatchCommand(FORMAT_TEXT_COMMAND, "strikethrough");
                    }
                });
            })();
        $[0] = editor;
        $[1] = handleSendClick;
        $[2] = t2;
    } else t2 = $[2];
    const onSend = t2;
    const t3 = !hasContent || isSubmitting;
    const t4 = !hasContent || isSubmitting ? "text.light.tertirary" : "bg.light.primary";
    let t5;
    if ($[3] !== t4) {
        t5 = /*#__PURE__*/ jsx(Box, {
            display: "flex",
            alignItems: "center",
            children: /*#__PURE__*/ jsx(Icon, {
                name: "send_outline",
                size: "24",
                color: t4
            })
        });
        $[3] = t4;
        $[4] = t5;
    } else t5 = $[4];
    let t6;
    if ($[5] !== classes.buttonPrimaryIconOnly || $[6] !== onSend || $[7] !== t3 || $[8] !== t5) {
        t6 = /*#__PURE__*/ jsx(Box, {
            pl: "16",
            children: /*#__PURE__*/ jsx(Button, {
                className: classes.buttonPrimaryIconOnly,
                disabled: t3,
                onClick: onSend,
                size: "large",
                variant: "primary",
                icon: t5
            })
        });
        $[5] = classes.buttonPrimaryIconOnly;
        $[6] = onSend;
        $[7] = t3;
        $[8] = t5;
        $[9] = t6;
    } else t6 = $[9];
    return t6;
};
export { SendFormPlugin };
